import { useState } from 'react';
import { Alert, Button, Flex, Form, Input, Result, Typography, theme } from 'antd';
import { Link } from 'react-router';
import { MENSAGEM_DE_FALHA_INESPERADA, TituloDaTela } from '@titularis/ui';
import { authClient } from '../../auth';

interface Campos {
  email: string;
}

export function EsqueciSenhaPage() {
  const { token } = theme.useToken();
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const pedir = async ({ email }: Campos) => {
    setErro(null);
    setEnviando(true);

    try {
      const { error } = await authClient.requestPasswordReset({
        email,
        redirectTo: `${window.location.origin}/nova-senha`,
      });

      if (error) {
        setErro('Não foi possível enviar o e-mail agora. Tente novamente em instantes.');
        return;
      }

      setEnviado(true);
    } catch {
      setErro(MENSAGEM_DE_FALHA_INESPERADA);
    } finally {
      setEnviando(false);
    }
  };

  if (enviado) {
    return (
      /* Mensagem propositalmente neutra: confirmar se o e-mail existe
         entregaria a terceiros quem tem conta na plataforma. */
      <Result
        style={{ padding: 0 }}
        status="info"
        title="Verifique seu e-mail"
        subTitle="Se houver uma conta com esse endereço, enviamos um link para você criar uma nova senha."
        extra={
          <Link to="/entrar">
            <Button type="primary" size="large" block>
              Voltar ao login
            </Button>
          </Link>
        }
      />
    );
  }

  return (
    <Flex vertical gap={token.margin}>
      <TituloDaTela
        titulo="Esqueci minha senha"
        descricao="Informe o e-mail da sua conta e enviaremos um link para criar uma nova senha."
      />

      {erro ? <Alert type="error" showIcon title={erro} /> : null}

      <Form<Campos> layout="vertical" onFinish={pedir} requiredMark={false} disabled={enviando}>
        <Form.Item
          name="email"
          label="E-mail"
          rules={[
            {
              required: true,
              type: 'email',
              message: 'Informe um e-mail válido.',
            },
          ]}
        >
          <Input autoComplete="email" inputMode="email" size="large" />
        </Form.Item>

        <Button type="primary" htmlType="submit" size="large" block loading={enviando}>
          Enviar link
        </Button>
      </Form>

      <Typography.Text type="secondary" style={{ textAlign: 'center' }}>
        <Link to="/entrar">Voltar ao login</Link>
      </Typography.Text>
    </Flex>
  );
}
